export default __webpack_public_path__ + "static/media/save.43c8b14b.svg";